function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
import React from 'react';
function isElement(value) {
    if (Array.isArray(value) || value === null) {
        return false;
    }
    if ((typeof value === "undefined" ? "undefined" : _type_of(value)) === "object") {
        if (value.type === React.Fragment) {
            return false;
        }
        return true;
    }
    return false;
}
export { isElement }; //# sourceMappingURL=is-element.js.map
